<script lang="ts">
    import TermsText from 'src/components/main/terms/components/terms-of-use/TermsOfUse.svelte'
    import VisitCommunity from 'src/components/main/#common/visit-community/VisitCommunity.svelte'
    import MainLayout from "../#common/layout/Layout.svelte"
</script>

<svelte:head>
    <title>Realis | Terms of Use</title>
    <meta name="description" content="You shall carefully read through this agreement before using Realis, and pay close attention to the written content. By clicking the «Accept» button below, you agree that this Agreement is enforceable like any written contract signed by you. You can contact Realis if you have any questions about this Agreement."/>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <TermsText/>
        <!--<VisitCommunity/>-->
    </svelte:fragment>
</MainLayout>
